const mfaActivationCodeTemplate = `<pwr-mfa linking-context="linkingContext"></pwr-mfa>`;
export default mfaActivationCodeTemplate;
